import gql from 'graphql-tag';

export const PEOPLE_COMPANY_DOCUMENT_ASSIGNMENT_FRAGMENT = gql`
	fragment peopleCompanyDocumentAssignment on CompanyDocumentAssignment {
		id
		source
		issuedTitle
		issuedContentHtml
		issuedAt
		issuedVersion
		requiresSignature
		issuedBy {
			id
			firstname
			lastname
		}
		stage
		cadence
		cycleKey
		dueAt
		status
		waivedAt
		resolvedAt
		employee {
			id
			firstName
			lastName
			preferredName
		}
		requirement {
			id
			requiresSignature
			cadence
			stage
		}
		companyDocument {
			id
			title
			categoryKey
			categoryLabel
			format
			contentHtml
			s3Key
			templateConfig
			formConfig
			version
			category {
				id
				key
				name
			}
		}
	}
`;

export const ISSUE_COMPANY_DOCUMENT = gql`
	mutation issueCompanyDocument($input: IssueCompanyDocumentInput!) {
		issueCompanyDocument(input: $input) {
			...peopleCompanyDocumentAssignment
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const GET_COMPANY_DOCUMENT_ASSIGNMENTS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: CompanyDocumentAssignmentFilter
	) {
		getCompanyDocumentAssignments(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...peopleCompanyDocumentAssignment
			}
			count
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const WAIVE_COMPANY_DOCUMENT_ASSIGNMENT = gql`
	mutation waiveCompanyDocumentAssignment($id: ID!) {
		waiveCompanyDocumentAssignment(id: $id) {
			...peopleCompanyDocumentAssignment
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const UNWAIVE_COMPANY_DOCUMENT_ASSIGNMENT = gql`
	mutation unwaiveCompanyDocumentAssignment($id: ID!) {
		unwaiveCompanyDocumentAssignment(id: $id) {
			...peopleCompanyDocumentAssignment
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;

export const REQUEST_COMPANY_DOCUMENT_ASSIGNMENT_REDO = gql`
	mutation requestCompanyDocumentAssignmentRedo($id: ID!, $dueAt: Date) {
		requestCompanyDocumentAssignmentRedo(id: $id, dueAt: $dueAt) {
			...peopleCompanyDocumentAssignment
		}
	}
	${PEOPLE_COMPANY_DOCUMENT_ASSIGNMENT_FRAGMENT}
`;
